<template>
  <Navagation/>
  <div>
    <h4>Query Expenses</h4>
    <br>
    <div class="input-field col s4">
      <select v-model="asset" id="asset">
        <option value="" disabled selected>Choose your Asset</option>
        <option value="14282 Greenview Drive">14282 Greenview Drive</option>
        <option value="14275 Penn Dixie Lane">14275 Penn Dixie Lane</option>
        <option value="861 Stouffer Avenue">861 Stouffer Avenue</option>
        <option value="Dodge Ram 3500 Truck">Dodge Ram 3500 Truck</option>
      </select>
      <label>Asset</label>
    </div>
    <div class="input-field col s4">
      <select v-model="category" id="category">
        <option value="" disabled selected>Choose your Category</option>
        <option value="School Tax">School Tax</option>
        <option value="Property Tax">Property Tax</option>
        <option value="Maintenance">Maintenance</option>
        <option value="Insurance">Insurance</option>
        <option value="Fuel">Fuel</option>
      </select>
      <label>Category</label>
    </div>
    <div class="input-field col s4">
      <select v-model="year" id="year">
        <option value="" disabled selected>Choose your Year</option>
        <option value="2025">2025</option>
        <option value="2024">2024</option>
        <option value="2023">2023</option>
        <option value="2022">2022</option>
        <option value="2021">2021</option>
      </select>
    </div>
    <a class="waves-effect waves-light btn" @click="filterExpenses">Search</a>
    <div class="row">
      <table class="highlight centered">
        <thead>
          <tr>
            <th></th>
            <th>Asset</th>
            <th>Category</th>
            <th>Amount</th>
            <th>Description</th>
            <th>Date</th>
            <th>File</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="expense in expenses" :key="expense.id">
            <td>
              <a class="btn-floating btn-large waves-effect waves-light red" :href="'/view?ID=' + expense.id">
                <i class="material-icons">search</i>
              </a>
            </td>
            <td> {{ expense.asset }} </td>
            <td> {{ expense.category }} </td>
            <td> {{ expense.amount }} </td>
            <td> {{ expense.description }} </td>
            <td> {{ expense.expense_date }} </td>
            <td> {{ expense.file }} </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="input-field col s6">
        <input v-model="query.count" id="expenses_count" type="text" class="validate">
        <label class="active" for="expenses_count">Expenses</label>
      </div>
      <div class="input-field col s6">
        <input v-model="query.total" id="expenses_total" type="text" class="validate">
        <label class="active" for="expenses_total">Total</label>
      </div>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import axios from 'axios'
import Navagation from '@/components/Navagation.vue'

const API_ENDPOINT = 'https://8c8gylju3m.execute-api.us-east-1.amazonaws.com/serverless_lambda_stage'

export default {
  name: 'App',
  components: { Navagation },

  data() {
    return {
      expenses: null,
      year: null,
      category: null,
      asset: null,
      searchable: null,
      query: {
        count: 0,
        total: 0
      }
    }
  },

  mounted() {
    this.retrieve()
    //axios.get(API_ENDPOINT + "/expenses")
     // .then(response => {
     //   this.expenses = response.data;
     //   this.searchable = response.data;
    //    console.log(response);
    //  });
    M.AutoInit()
  },

  methods: {

    retrieve: function () {
      axios.get(API_ENDPOINT + "/expenses")
        .then(response => {
          this.expenses = response.data;
          this.searchable = response.data;
        });
    },

//    search: function () {
//      console.log(this.category)
//      console.log(this.asset)
//      console.log(this.year)
//      var id = null;
//      var results = []
//      for (id in this.searchable) {
//        if (this.searchable[id].asset == this.asset) {
//          console.log(this.searchable[id].asset)
//          results.push(this.searchable[id])
//        }
//      }
//      this.expenses = results
//      this.query.count = this.updateCount(results)
//      this.query.total = this.updateTotal(results)
//    },

    addDateFields: function (list) {
      var id = 0;
      for (id in list) {
        var date = null;
        date = new Date(Date.parse(list[id].expense_date))
        list[id]["year"] = date.getFullYear()
        list[id]["month"] = date.getMonth()
        list[id]["day"] = date.getDate()
      }
      return list;
    },

    filterExpenses: function () {
      // Clear Current Expenses
      this.expenses = []

      // Add Date Information
      var results = this.addDateFields(this.searchable);
      
      // Filter Data
      results = this.filter("category", this.category, results)
      results = this.filter("asset", this.asset, results)
      results = this.filter("year", this.year, results)

      // Check if Empty
      if(results.length == 0) {
        this.expenses = "No results found";
      }
      else {
        this.expenses = results;
      }

      
      this.query.count = this.updateCount(results)
      this.query.total = this.updateTotal(results)
    },

    filter: function (key, value, list) {
      var id = 0;
      var results = [];
      if (value !== null) {
        for (id in list) {
          if (list[id][key] == value) {
            results.push(list[id])
          }
        }
        return results;
      }
      return list;
    },

    updateCount: function (results) {
      var count = results.length;
      return count;
    },
    updateTotal: function (results) {
      var total = Number(0.00).toFixed(2);
      var id;
      for (id in results) {
        total = (Number(total)) + (Number(results[id].amount));
        total = total.toFixed(2)
      }
      // Format Result for UI
      console.log(total)
      total = "$" + total;
      return total;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>